






































































































































































import { Vue, Component } from "vue-property-decorator";
import {
  getPartTimeFactor,
  updatePartTimeFactor,
  generateFiles,
} from "@/api/humanCapital";
import { IResponseData } from "@/utils/request";
import ajax from "@/utils/upload-ajax";
type UploadItem = {
  id: number;
  company: string;
  format: string;
  regionCN: string;
  shortName: string;
  nameExcept?: string;
  uploaded: boolean;
  hasLaborDispatch?: number;
  hiddenMark?: string;
  showCompany?: string;
  uploadedFile?: string;
};
@Component
export default class HumanCapital extends Vue {
  private partTimeFactor = "1";
  private taskId = "";
  private taskMonth = "";
  private payrollUploads: Array<UploadItem> = [
    {
      id: 1,
      company: "北京一帆",
      format: "bj",
      regionCN: "北京",
      shortName: "一帆",
      uploaded: false,
    },
    {
      id: 8,
      company: "太原一帆",
      format: "bj",
      regionCN: "太原",
      shortName: "一帆",
      uploaded: false,
    },
    {
      id: 2,
      company: "北京云天",
      format: "bj",
      regionCN: "北京",
      shortName: "云天",
      uploaded: false,
    },
    {
      id: 3,
      company: "北京星聚梨",
      format: "bj",
      regionCN: "北京",
      shortName: "星聚梨",
      hasLaborDispatch: 1,
      uploaded: false,
    },
    {
      id: 4,
      company: "成都一帆",
      format: "cd",
      regionCN: "成都",
      shortName: "一帆",
      uploaded: false,
    },
    // {
    //   id: 5,
    //   company: "成都中润",
    //   format: "cd",
    //   regionCN: "成都",
    //   shortName: "中润",
    //   uploaded: false,
    // },
    // {
    //   id: 6,
    //   company: "成都一帆新元",
    //   format: "cd",
    //   regionCN: "成都",
    //   shortName: "新元",
    //   uploaded: false,
    // },
    // {
    //   id: 7,
    //   company: "杭州星聚梨",
    //   format: "bj",
    //   regionCN: "杭州",
    //   shortName: "星聚梨",
    //   uploaded: false,
    // },
    {
      id: 8,
      company: "北京煦游",
      format: "bj",
      regionCN: "北京",
      shortName: "煦游",
      uploaded: false,
    },
  ];
  private insuranceUploads: Array<UploadItem> = [
    {
      id: 11,
      company: "北京一帆",
      format: "bj",
      regionCN: "北京",
      shortName: "一帆",
      uploaded: false,
    },
    {
      id: 18,
      company: "太原一帆",
      format: "bj",
      regionCN: "太原",
      shortName: "一帆",
      uploaded: false,
    },
    {
      id: 12,
      company: "北京云天",
      format: "bj",
      regionCN: "北京",
      shortName: "云天",
      uploaded: false,
    },
    {
      id: 13,
      company: "北京星聚梨",
      format: "bj",
      regionCN: "北京",
      shortName: "星聚梨",
      nameExcept: "劳派",
      uploaded: false,
    },
    {
      id: 14,
      company: "北京星聚梨",
      showCompany: "北京星聚梨劳派",
      format: "bj",
      regionCN: "北京",
      shortName: "星聚梨劳派",
      hasLaborDispatch: 1,
      // hiddenMark: "广州",
      uploaded: false,
    },
    {
      id: 15,
      company: "成都一帆",
      format: "cd",
      regionCN: "成都",
      shortName: "一帆",
      uploaded: false,
    },
    // {
    //   id: 16,
    //   company: "成都中润",
    //   format: "cd",
    //   regionCN: "成都",
    //   shortName: "中润",
    //   uploaded: false,
    // },
    // {
    //   id: 17,
    //   company: "成都一帆新元",
    //   format: "cd",
    //   regionCN: "成都",
    //   shortName: "新元",
    //   uploaded: false,
    // },
    // {
    //   id: 18,
    //   company: "杭州星聚梨",
    //   format: "bj",
    //   regionCN: "杭州",
    //   shortName: "星聚梨",
    //   uploaded: false,
    // },
    {
      id: 19,
      company: "北京煦游",
      format: "bj",
      regionCN: "北京",
      shortName: "煦游",
      uploaded: false,
    },
  ];
  private partTimeUpload = { uploaded: false };

  get uploadPartTimeData(): Record<string, string> {
    return {
      month: this.taskMonth,
      task_id: this.taskId,
    };
  }

  private getUploadData(item: UploadItem, fileType: string) {
    let data: Record<string, string> = {
      file_type: fileType,
      company: item.company,
      month: this.taskMonth,
      task_id: this.taskId,
      file_format: item.format,
    };
    if (item.hasLaborDispatch) {
      data["has_labor_dispatch"] = item.hasLaborDispatch.toString();
    }
    if (item.hiddenMark) {
      data["hidden_mark"] = item.hiddenMark;
    }
    return data;
  }

  private getFullPath(path: string) {
    return `${process.env.VUE_APP_BASE_API_PATH}${path}`;
  }

  private mounted() {
    let nowdays = new Date();
    let year = nowdays.getFullYear();
    let month = nowdays.getMonth();
    if (month == 0) {
      month = 12;
      year = year - 1;
    }
    this.taskMonth = month < 10 ? `${year}0${month}` : `${year}${month}`;
    this.getPartTimeFactor();
    this.taskId = this.taskMonth; // 用月份作为任务ID
  }

  private async getPartTimeFactor() {
    try {
      const { code, data, message } = await getPartTimeFactor();
      if (code === 0) {
        this.partTimeFactor = data.factor;
      } else {
        this.$message.error(`获取兼职乘数失败:${message}`);
      }
    } catch (e) {
      this.$message.error((e as Error).message);
    }
  }
  private async updatePartTimeFactor(factor: string) {
    try {
      const { code, message } = await updatePartTimeFactor(factor);
      if (code === 0) {
        this.$message.success("保存兼职乘数成功");
      } else {
        this.$message.error(`保存兼职乘数失败:${message}`);
      }
    } catch (e) {
      this.$message.error((e as Error).message);
    }
  }
  private handleFactorEditClick() {
    this.updatePartTimeFactor(this.partTimeFactor);
  }
  private handleUploadShareSuccess(resp: IResponseData<Record<string, never>>) {
    if (resp.code === 0) {
      this.$message.success("上传成功");
    } else {
      this.$message.error(`上传失败:${resp.message}`);
    }
  }
  private handleUploadShareFailed(err: unknown) {
    this.$message.error(`上传失败:${err}`);
  }

  private generateUploadSuccessHandler(uploadItem: UploadItem) {
    return (resp: IResponseData<Record<string, never>>) => {
      if (resp.code === 0) {
        this.$message.success("上传成功");
        uploadItem.uploaded = true;
      } else {
        this.$message.error({
          dangerouslyUseHTMLString: true,
          message: `上传失败:${resp.message}`,
          duration: 0,
          showClose: true,
        });
        uploadItem.uploaded = false;
      }
    };
  }
  private generateUploadFailedHandler(uploadItem: UploadItem) {
    return (err: unknown) => {
      this.$message.error(`上传失败:${err}`);
      uploadItem.uploaded = false;
    };
  }
  private async handleGenerate() {
    try {
      const { code, data, message } = await generateFiles(
        this.taskId,
        this.taskMonth
      );
      if (code === 0) {
        const { warnings, file_path } = data;
        const filePath = this.getFullPath(file_path);
        if (warnings && warnings.length > 0) {
          this.$alert(warnings.join("<br>"), "已完成但有警告", {
            confirmButtonText: "确定",
            dangerouslyUseHTMLString: true,
            callback: () => {
              window.open(filePath);
            },
          });
        } else {
          window.open(filePath);
        }
      } else {
        this.$message.error(`生成失败:${message}`);
      }
    } catch (e) {
      this.$message.error((e as Error).message);
    }
  }

  private tableRowClassName(rowInfo: Record<string, unknown>) {
    if ((rowInfo.row as UploadItem).uploaded) {
      return "uploaded-row";
    }
    return "";
  }

  private matchAndUploadFiles(fileType: string) {
    let uploads: Array<UploadItem> = [];
    switch (fileType) {
      case "payroll":
        uploads = this.payrollUploads;
        break;
      case "insurance":
        uploads = this.insuranceUploads;
        break;
    }
    return (options: Record<string, unknown>) => {
      let { name } = options.file as File;
      let matchUploads = uploads.filter(
        (item) =>
          name.indexOf(item.regionCN) !== -1 &&
          name.indexOf(item.shortName) !== -1 &&
          (!item.nameExcept || name.indexOf(item.nameExcept) === -1)
      );
      if (matchUploads.length === 0) {
        // 匹配不到，忽略
        this.$message.warning(`文件未匹配到公司${name}`);
        return;
      } else if (matchUploads.length > 1) {
        // 匹配到多个，提示
        this.$message.warning(`文件匹配到多个公司${name}`);
        return;
      }
      let item = matchUploads[0];
      let data = this.getUploadData(item, fileType);
      options.data = data;
      options.onSuccess = this.generateUploadSuccessHandler(item);
      options.onError = this.generateUploadFailedHandler(item);
      item.uploadedFile = name;
      return ajax(options);
    };
  }
}
